// extracted by mini-css-extract-plugin
export default {"table":"PropertyKeySettings_table__W57Jc","fieldPopup":"PropertyKeySettings_fieldPopup__k4VNM"};